module.exports = "img/15.8822cf.webp";